/**
 * useRemarksCategoryListScreen.js
 * -------------------------------
 * Headless Hook for Remarks Category Master list screen using shared useMasterList
 * and asynchronous JobEngine export.
 * 100% conforming to module_implementation_standards.md.
 */
import { useMasterList } from '../../common/useMasterList';
import * as remarksCategoryApi from '../api/remarksCategoryApi';
import { useExportJob } from '../../../../hooks/useExportJob';
import { executePrintReport } from '../../../../utils/printReportUtil';

export function useRemarksCategoryListScreen() {
  const master = useMasterList({
    entityName: 'Remarks Category',
    apiClient: remarksCategoryApi.remarksCategoryClient,
    fetchList: remarksCategoryApi.listRemarksCategories,
    archiveItem: remarksCategoryApi.archiveRemarksCategory,
    deleteItem: remarksCategoryApi.deleteRemarksCategory,
  });

  const { triggerExport, isExporting } = useExportJob({
    module: 'remarks-category',
    fileFormat: 'XLSX',
  });

  const handleToolSelect = (toolKey) => {
    if (toolKey === 'download' || toolKey === 'export_excel') {
      triggerExport({
        viewMode: master.state.viewMode,
        searchText: master.state.searchText,
      });
    } else if (toolKey === 'print') {
      executePrintReport({
        title: 'Remarks Category Master Registry',
        subtitle: 'Enterprise Remark & Observation Classifications',
        columns: [
          { header: 'ID', accessor: 'id' },
          { header: 'Category Name', accessor: 'name' },
          { header: 'Description / Scope', accessor: 'description' },
          { header: 'Status', accessor: 'status' },
          { header: 'Created Date', accessor: 'created_on' },
        ],
        rows: master.state.rows || [],
      });
    }
  };

  return {
    ...master,
    state: {
      ...master.state,
      isExporting,
    },
    actions: {
      ...master.actions,
      handleToolSelect,
    },
  };
}
